import { FormMixin } from '@artup/client'

export default {
  inject: {
    accounts: { from: 'accountsStore' }
  },

  mixins: [
    FormMixin
  ],

  props: {
    // Account details, passed by the layout view to every nested view
    account: {
      required: true
    }
  }
}
